import { genericMemo } from "@redotech/react-util/component";
import { ReactNode } from "react";

export type WidgetProps<E> = { element: E };

export interface WidgetEditorProps<T extends WidgetProps<E>, E> {
  widget: T;
  setElement: (element: E) => void;
  onSelectElement: (
    elementIndex: number,
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => void;
  selected: boolean;
  index: number;
}

export type WidgetEditorDecorator<T extends WidgetProps<E>, E> = {
  children: (props: WidgetEditorProps<T, E>) => ReactNode;
} & WidgetEditorProps<T, E>;

export const withEditor = <T extends WidgetProps<E>, E>(
  Decorator: React.FC<WidgetEditorDecorator<T, E>>,
  Component: React.FC<T>,
) => {
  return genericMemo(function FormElementEditor(
    props: WidgetEditorProps<T, E>,
  ) {
    return (
      <Decorator {...props}>{() => <Component {...props.widget} />}</Decorator>
    );
  });
};
